import { Modal } from "antd";
import type { NavigateFunction } from "react-router-dom";

export const goToRestaurantsWithLocation = (navigate: NavigateFunction) => {
    if (!navigator.geolocation) {
        Modal.warning({
            title: "Location unavailable",
            content: "Your browser doesn't support location services. You can still browse, but nearby results may not be accurate.",
            onOk: () => navigate("/restaurantsPage"),
        });
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            navigate(`/restaurantsPage/${lat}/${lng}`);
        },
        (error) => {
            if (error.code === error.PERMISSION_DENIED) {
                Modal.warning({
                    title: "Location access needed",
                    content: "Please enable location permissions so we can show restaurants near you.",
                    onOk: () => navigate("/restaurantsPage"),
                });
            } else {
                Modal.warning({
                    title: "Location unavailable",
                    content: "We couldn't determine your location right now. You can still browse and set your address manually.",
                    onOk: () => navigate("/restaurantsPage"),
                });
            }
        }
    );
};